<template lang="html">
<Layout style="margin: 20px 300px;" class="content-sm">
  
    <Content>
       
      <h2>
        <Icon type="ios-briefcase"/>
        Gestione Centri
      </h2>
  <Spin size="large" fix v-if="loading"/>
  <div v-if="!loading">
    <br>
    <Button
    style="float: right"
    @click="$store.logout()"
    type="error">
      <Icon type="log-out"/>
      Esci
    </Button>
    <Button
    type="primary"
    style="float: left"
    @click.native="refreshCompanies()">
      <Icon type="refresh"/>
    </Button>
    &nbsp;
    <Button
    @click.native="show_form = !!(form = newForm())"
    type="primary"
    style="float: left; margin-left: 5px">
      <Icon type="plus-round"/>
      Aggiungi
      
    </Button>
    &nbsp;
    <Input style="width: 15rem" v-model="filters.search" autofocus type="text" placeholder="Ricerca..."/>
    &nbsp;
    <Checkbox id="with_trashed" v-model="filters.with_trashed"/>
    <Label for="with_trashed">Visualizza centri disabilitati</Label>
    <!--
    <div style="margin: 10px;overflow: hidden" v-if="associates && associates.length > page_size">
      <Page :total="associates.length" :page-size="page_size" :current="page+1" @on-change="changePage"></Page>
    </div>-->
    <div  style="margin: 1em 0">
      <!-- <Table :columns="cols" :data="current_data" :loading="loading" stripe/> -->

      <div v-if="current_data.length!=0" class="ivu-table spaced centri-table" style="margin: 1em 0; ;" :loading="loading">

        <table>
          <thead>
            <tr> 
              <th v-for="col in cols" :key="col.id"
              @click="col.sortable && toggleSort(col)" :class="{sortable: col.sortable}" :col="col.key">
                {{ col.title }}
                <Icon v-if="sort_by.key == col.key" :type="'ios-arrow-'+(sort_by.asc?'down':'up')"/>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="cent in current_data" :key="cent.id">
              <td v-for="col in cols" :key="col.id">
                  
                <div v-if="col.key == 'action'" class="azioni-centro">
                  <Button type="primary" size="small" @click="visualizza(cent)">
                    <Icon type="ios-eye"/>
                  </Button>
                  <Button v-if="!cent.deleted_at" type="primary" size="small" @click="show_form = !!(form = _.clone(cent))">
                    <Icon type="edit"/>
                  </Button>
                  <Button v-if="user.is_admin&&!cent.deleted_at" type="error" size="small" @click="delCompany(cent)">
                    <Icon type="trash-a"/>
                  </Button>
                  <Button v-if="user.is_admin&&cent.deleted_at" type="warning" size="small" @click="detrashCompany(cent)">
                    <Icon type="android-download" />
                  </Button>
                </div>
                <div v-if="col.key == 'roles'" >
                    <table>
                        <thead>
                            <tr>
                                <th style="width:50%">
                                Utente
                                </th>
                                <th style="width:50%">
                                Ruolo
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="role in cent[col.key]">
                                <td>
                                {{role.user.name}}
                                </td>
                                <td>
                                {{role.role}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <template v-else>
                  <a v-if="col.key == 'name'&&!cent.deleted_at" @click="$store.company=cent" style="font-size:17px;">
                    {{ col.map_fn ? col.map_fn(cent) : cent[col.key] }}
                  </a>
                  <a v-else-if="col.key == 'name'&&cent.deleted_at" style="font-size:17px;color:Tomato;">
                    {{ col.map_fn ? col.map_fn(cent) : cent[col.key] }}
                  </a>
                  <div v-else>
                    {{ col.map_fn ? col.map_fn(cent) : cent[col.key] }}
                  </div>
                  
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        Nessun centro trovato
      </div>
    </div>
    <div style="margin: 10px;overflow: hidden" v-if="companies && companies.length > page_size">
      <Page :total="companies.length" :page-size="page_size" :current="page+1" @on-change="changePage"></Page>
    </div>


    <Modal
    :mask-closable="false"
    :transfer="true"
    v-model="show_form"
    class-name="large"
    :title="(form && form.id ? 'Modifica' : 'Nuovo') + ' centro'">
      <CentroForm ref="company_form" v-if="form" :form="form"/>
      <div slot="footer"><!--
        <Button type="error" @click.native="show_form=false">
          Annulla
        </Button>
        <Button type="primary" @click.native="post(form)">
          Salva
        </Button>-->
      </div>
    </Modal>

    <Modal v-model="show_details_modal">
      <div v-if="show_details">
          
        
        Nome: <b>{{ show_details.name || '-' }}</b><br>
        Logo:
        <b><img v-if="!show_details.logo" :src="`${$store.config.API_URL}/logo/${show_details.id}`" alt='-' style="width:100%"></b><br>
        Partita IVA: <b>{{ show_details.piva || '-' }}</b><br>
        Codice Fiscale <b>{{ show_details.cf || '-' }}</b><br>
        Telefono: <b>{{ show_details.telehone || '-' }}</b><br>
        Fax: <b>{{ show_details.fax || '-' }}</b><br>
        Email: <b>{{ show_details.email || '-' }}</b><br>
        Indirizzo: <b>{{ show_details.addr_street || '-' }}</b><br>
        Città: <b>{{ show_details.addr_city || '-' }}</b><br>
        Provincia: <b>{{ show_details.province || '-' }}</b><br>
        CAP: <b>{{ show_details.addr_zip || '-' }}</b><br>
        Legale Rappresentante: <b>{{ show_details.legale_name || '-' }}</b><br>
        Contatto del Legale: <b>{{ show_details.legale_email || '-' }}</b><br>

        
        
        <div>
          <br>
          <div class="content" style="margin-left: 0.5rem">
            Gestione IVA:  <b>{{ show_details.has_iva ? 'Sì' : 'No' }}</b><br>
            Movimenti in partita doppia:  <b>{{ show_details.has_partita_doppia ? 'Sì' : 'No' }}</b><br>

            Privacy policy: <wysiwyg  v-model="show_details.privacy_policy" />
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button type="error" @click.native="show_details_modal=false">
          Chiudi
        </Button>
      </div>
    </Modal>

  </div>

    </Content>
  </Layout>
</template>

<script>
import collect from 'collect.js'
import CentroForm from './company-form'

export default {
   store: {
    user: 'session.user',
  },
  name: 'centri-list',

  components: {
    CentroForm,
  },

  data() {
    return {
      page: 0,
      page_size: 100,
      cards: null,
      show_details_modal: false,
      show_details: true,
      renew_associate: false,
      console,
      loading: true,
      filters: {
        enabled: 1,
        search: '',
        enabled_date: null,
        with_trashed: false,
      },
      form: null,
      show_form: false,
      companies: null,
      show: [
        'iscritto',
        'stato'
      ],
      sort_by: {
        key: 'name',
        asc: true,
      },
    }
  },

  mounted() {
    this.refreshCompanies()
  },

  methods: {
    newForm() {
      return {
        number: undefined,//this.$http.get('last-associate-id/'+this.$store.company.id),
        first_name: undefined,
        last_name: undefined,
        cf: undefined,
        doc: undefined,
        addr_street: undefined,
        addr_city: undefined,
        addr_zip: undefined,
        addr_prov: undefined,
        birth_date: undefined,
        birth_city: undefined,
        birth_prov: undefined,
        email: undefined,
        pec: undefined,
        telephone: undefined,
        second_phone: undefined,
        notes: undefined,
        meta: {},
      }
    },
    toggleSort (col) {
      if (this.sort_by.key == col.key) {
        this.sort_by.asc = !this.sort_by.asc
      } else {
        this.sort_by = {
          key: col.key,
          asc: true,
        }
      }
    },
    visualizza (cent) {
      this.show_details = cent
      this.show_details_modal = true

      setTimeout(() => {
      }, 10)
    },
    changePage (page) {
      this.page = page-1
    },
    refreshCompanies(page) {
      var params = Object.assign({
        page: page || 1,
      }, this.filters)

      this.loading = true
      this.$http.get('companies', { params }).then(
        res => {
        this.companies = res.data.data
        this.page = 0
        this.companies.forEach(cent => {
          if (cent.number == cent.number*1) cent.number*=1
        })
        if (!this.user.is_admin && this.user.c_count == 1 && this.user.status) {
          
          this.$store.company = this.companies[0]}  
        }
        
        ).finally(() => {
        this.loading = false

      })
    },
    post(data) {
    },
    delCompany(a) {
        confirm('Sicuri?') && this.$http.delete('companies/'+a.id).then(() => this.refreshCompanies())
    },
    detrashCompany(a) {
         confirm('Sicuri di voler riabilitare questo centro?') && this.$http.get('restore-company/'+a.id).then(() => this.refreshCompanies())
    },
  },

  watch: {
    filters: {
      deep: true,
      handler: require('lodash').debounce(function() {
        this.refreshCompanies()
      }, 300)
    },
  },

  computed: {
    all_current_data () {
      console.log('recalc data')
      console.log(typeof this.companies)
      let cent = this.companies || []
      cent = collect(cent)
      let sb = this.sort_by
      var col = this.cols.find(x => x.key == sb.key)
      cent = cent[sb.asc ? 'sortBy' : 'sortByDesc'](col.order_fn || (cent => {
        return String(cent[col.key] || '').toLocaleLowerCase().trim()
      })).toArray()
      console.log('recalc data end')
      return cent
    },
    current_data () {
      return this.all_current_data.slice(this.page*this.page_size, (this.page+1)*this.page_size)
    },
    cols () {
      var cols = []
      cols.push({
        title: 'Nome',
        key: 'name',
        sortable: true,
        width: 100,
        // fixed: 'left',
      })
      cols.push({
        title: 'Amministratori',
        key: 'roles',
        sortable: false,
        // fixed: 'left',
      })
      cols.push({
        title: 'Città',
        key: 'addr_city',
        sortable: true,
      })
      cols.push({
        title: 'Provincia',
        key: 'provincia',
        sortable: true,
      })
      cols.push({
        width: 210,
        title: 'Azioni',
        key: 'action',
        align: 'center',
      })

      return cols
    }
  }
}
</script>

<style lang="scss">
.nolabelmargin {
  .ivu-form-item-content {
    margin-left: 0!important;
  }
}
.centri-table {
  th.sortable {
    cursor: pointer;
  }
  &[loading] {
    opacity: .4;
  }
  .azioni-centro {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    button {
      margin-right: 4px;
      border-radius: 6px;
    }
  }

  th[col=action] {
    width: 0;
  }
}
</style>